import { useCampaignStore } from '@lidea/shared/data-access/core';
import { useQuery } from '@tanstack/react-query';

import { plotsApi } from '../../apis/plots-api';
import { plotKeys } from './../../keys/plot-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UsePlotsMaxBoundsProps {}

export function usePlotsMaxBounds() {
  const campaignId = useCampaignStore((s) => s.campaignId);

  const query = useQuery({
    queryKey: plotKeys.maxBounds(campaignId),
    queryFn: () => plotsApi.getMaxBounds(),
    enabled: !!campaignId,
  });

  return query;
}

export default usePlotsMaxBounds;
